import { normalizeCountryCode as normalizeBaseCountryCode } from "../../../utils/Countries";
export {
  downloadBlobFile,
  downloadCsvFile,
} from "../../../utils/download";

export const normalizeTradeShowCountryCode = (value) => {
  if (!value) return "";

  const normalizedValue = value.toString().trim().toUpperCase();

  if (normalizedValue === "UNITED STATES OF AMERICA") {
    return "US";
  }

  return normalizeBaseCountryCode(normalizedValue);
};

export const looksLikePlaceholderTradeShowName = (value) => {
  const name = String(value || "")
    .trim()
    .toLowerCase();

  if (!name) return true;
  if (/^no\s*filters?\s*applied/.test(name)) return true;
  if (/^[-–—]+$/.test(name)) return true;
  if (name === "." || name === "n/a") return true;

  return false;
};

export const normalizeTradeShowUrl = (url) => {
  if (!url) return "";

  const value = String(url).trim();

  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;

  return `https://${value}`;
};

export const getTradeShowMonthAndYear = (startDateRaw) => {
  if (!startDateRaw) {
    return { month: "", year: "" };
  }

  return {
    month: startDateRaw.slice(5, 7),
    year: startDateRaw.slice(0, 4),
  };
};
